import { Button as UIButton } from "@mui/material";
import { ReactNode } from "react";

export function SimpleMuiButton({
  children,
  disabled,
  onClick,
  icon,
  className,
}: {
  children: ReactNode;
  disabled: boolean;
  onClick: (...args: any) => any;
  icon: ReactNode;
  className: string;
}) {
  return (
    <UIButton
      disabled={disabled}
      style={{ textTransform: "none" }}
      className={className}
      onClick={onClick}
      startIcon={icon}
    >
      {children}
    </UIButton>
  );
}
